<template>
	<page>
		<module drag="disabled">
			<module-col size="190">
				<ul class="menu">
					<li v-for="(item, i) in operationDicList" :key="i" class="flex-between-center" @click="loadOperationDicDetail(item)">
						<p>{{item.dic_name}}</p>
					</li>
				</ul>
			</module-col>

			<module-col enable-flex>
				<m-operate>
					<c-button color="main" v-if="auth('b_operation_dic_edit')" :disabled="!this.dicId" prepend-icon="tf-add" @click="edit()">添加字典值</c-button>
				</m-operate>

				<c-table ref="list" height="grow" :paging="false">
                    <c-table-column  type="drag" @handle="dragHandle"></c-table-column>

					<c-table-column
						label="字典值"
						name="value"
						width="200"
					></c-table-column>

					<c-table-column
						label="其他配置"
						name="config_json"
						width="200"
					>
                        <template #default="{data}">
                            <span v-if="data.config_json && data.config_json.kind">
                                报销类型: <c-state dict="expenseItemTypeDic" :value="data.config_json.kind"></c-state>
                            </span>
                            <span v-else>-</span>
						</template>
                    </c-table-column>

					<c-table-column
						label="创建时间"
                        name="create_date"
                        width="100"
					>
					</c-table-column>

					<c-table-column
						type="button"
						label="操作"
						width="110"
					>
						<template #default="{data}">
                            <c-table-button v-if="auth('b_operation_dic_edit')" icon="tf-edit" @click="edit(data)">编辑</c-table-button>
							<c-table-button v-if="auth('b_operation_dic_edit')" icon="tf-trash" @click="deleteHandle(data)">删除</c-table-button>
						</template>
					</c-table-column>
				</c-table>
			</module-col>

            <!--创建/编辑信息弹窗-->
            <operation-dic-edit ref="operationDicEdit" @resolve="$refs.list.update()"></operation-dic-edit>
		</module>
	</page>
</template>

<script>
    import operationDicEdit from "@/pages/basic/operation_dic_edit.vue";

	export default {
		components: {
            operationDicEdit
        },
		
		props: {
			type: String
		},

		data() {
			return {
                dicId:0,
                dicName:'',
                operationDicList:[]
			}
		},

		computed: {
		},

		watch: {
		},

		mounted() {
			this.initOperationDic();
		},

		methods: {
            initOperationDic() {
                this.request({
                    url: '/operation/dic/list',
                    data: {},
                    loading: true,
                    success: data => {
                        this.operationDicList = data;
                    }
                })
			},

            //加载字典详情
            loadOperationDicDetail(data){
                this.dicId = data.id;
                this.dicName = data.dic_name;
                this.$refs.list.load({
                    url: '/operation/dic/detail/list',
                    data: {
                        dic_id: this.dicId
                    },
                });
            },
            /******新建/编辑*******/
            edit(data) {
                if (!data){
                    data = {};
                }
                data.dic_id = this.dicId;
                data.dic_name = this.dicName;
                this.$refs.operationDicEdit.open(data);
            },
            //删除数据
			deleteHandle(data) {
				this.$confirm({
					title: '确认删除字典值【'+data.value+'】？',
					message: '删除后不可恢复,请谨慎操作',
					resolve: () => {
						this.request({
							url: '/operation/dic/detail/remove',
							data: {
								id: data.id
							},
							loading: true,
							success: () => {
								this.$message({
                                    type: 'success',
                                    message: '删除成功'
								});
								this.$refs.list.update();
							}
						})
					}
				});
			},
            //字典数据排序
            dragHandle() {
                this.request({
                    url: '/operation/dic/detail/sort',
                    data: {
                        dic_id: this.dicId,
                        dic_detail_list: this.$refs.list.getData().map((item, index) => {
                            return {
                                id: item.id,
                                sort_id: index + 1
                            }
                        })
                    },
                    success: () => {
                        this.$message({
                            type: 'success',
                            message: '排序成功'
                        });
                        this.$emit('sort', false);
                    }
                })
            }
		}
	}
</script>

<style lang="stylus" scoped>
	.menu {
		padding: 12px 0;

		li {
			position: relative;
			height: 40px;
			padding: 0 12px 0 20px;
			font-size: 13px;
			color: #444;
			cursor: pointer;

			&:hover {
				background: #F7F7F7;
			}

			&.z-crt {
				font-weight: bold;
				color: var(--color-main);
				background: #F7F7F7;
				
				&:before {
					content: '';
					position: absolute;
					left: 0;
					top: 0;
					bottom: 0;
					width: 3px;
					background: var(--color-main);
				}
			}
		}
	}
</style>